/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Vast_Vole_LiftInputs */

const en_warm_vast_vole_lift = /** @type {(inputs: Warm_Vast_Vole_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Imports`)
};

const de_warm_vast_vole_lift = /** @type {(inputs: Warm_Vast_Vole_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeschlossene Imports`)
};

/**
* | output |
* | --- |
* | "Closed Imports" |
*
* @param {Warm_Vast_Vole_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_vast_vole_lift = /** @type {((inputs?: Warm_Vast_Vole_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Vast_Vole_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_vast_vole_lift(inputs)
	return de_warm_vast_vole_lift(inputs)
});